<div class="col-md-12" *ngIf="isLoading"
  style="position: fixed; top: 0; left: 0; width: 100%;height: 100%;    z-index:99;">
  <app-busy [message]="message"></app-busy>
</div>
<div class="row m-0">
  <div style="margin-top:10px; margin-bottom:-10px;">
    <h4><span style="padding-right:15px"></span> <i class="fa fa-cogs"></i> External: <b>Vehicles</b></h4>
  </div>
</div>
<hr>
<fieldset class="card border-light shadow-sm" style="margin:2px 0px;padding:2px 0px 2px 15px;">
  <legend class="scheduler-border tsk-display blackcontrol">Filters</legend>
  <div class="row m-0" style="padding:0px;">
    <div class="" style="width:  20%!important; padding: 2px !important; ;margin:1px!important;">
      <select title="Select vehicle type..." class="form-control" [(ngModel)]="vehicleType">
        <option value="" disabled selected>Select Vehicle Type...</option>
        <option value="">Select none</option>
        <option *ngFor="let vehicletype of vehicletypes" [value]="vehicletype.id">{{vehicletype.description}}</option>
      </select>
    </div>
    <!-- <div class="" style="width: 14%!important; padding: 2px !important; ;margin:1px!important;">
      <select title="Select permit type..." class="form-control" [(ngModel)]="permitType">
        <option value="" disabled selected>Select permit type...</option>
        <option value="">Select none</option>
        <option *ngFor="let permittype of permittypes" [value]="permittype.id">{{permittype.description}}</option>
      </select>
    </div> -->
    <div class="" style="width:  20%!important; padding: 2px !important; ;margin:1px!important;">
      <input type="text" class="form-control form-control-lg pull-left" [(ngModel)]="vinnumber"
        placeholder="Enter VIN Number..." title="VIN number to search for..." oninput="this.value = this.value.toUpperCase()">
    </div>
    <div class="" style="width:  20%!important; padding: 2px !important; ;margin:1px!important;">
      <input type="text" class="form-control form-control-lg" [(ngModel)]="regnumber"
        placeholder="Enter Registration Number..." title="Register number to search for.">
    </div>
    <!-- <div class="" style="width: 14%!important; padding: 2px !important; ;margin:1px!important;">
      <input type="text" class="form-control form-control-lg" [(ngModel)]="carriername"
        placeholder="Enter Carrier Name..." title="Carrier Name to search for.">
    </div> -->

    <!-- <div class="" style="width: 14%!important; padding: 2px !important; ;margin:1px!important;">
      <input type="text" class="form-control form-control-lg" [(ngModel)]="carriercode"
        placeholder="Enter Carrier Code..." title="Carrier Code to search for.">
    </div> -->

    <div class="col-1 btn-show" style="width:14%!important;margin:0px!important;padding:0px!important;">
      <span (click)="onReset()" title="Reset filters..." class="btn btn-success btn-md pull-right" ><i class="fa fa-undo" aria-hidden="true"></i></span>
      <span title="Apply filters..."  (click)="onCarrierSearch()" class="btn btn-primary btn-md pull-right" style="margin-right:4px!important;"><i class="fa fa-search" aria-hidden="true"></i></span>

    </div>
  </div>
</fieldset>
<br>
<fieldset style="margin:0px;padding:0px;">
  <!-- <legend class="scheduler-border tsk-display blackcontrol">Vehicles</legend> -->
  <div class="row m-0" style="padding:0px">
    <div class="col-12" style="margin:0px!important;">
      <table class="table table-sm table-striped manage-vehicles" style="width:100%;">
        <thead class="thead-inverse">
          <tr class="hd-clpse">
            <th class="bfr-end-col" rowspan="2" *ngIf="isMyVehicles">
              <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagAN == 2),'fa-sort-desc sort-d': (flags.flagAN == 3), 'fa-sort':(flags.flagAN == 1) }" (click)="onSort(1)"></i> -->
            </th>
            <th class="bfr-end-col" rowspan="2">
              Vin
              <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagAN == 2),'fa-sort-desc sort-d': (flags.flagAN == 3), 'fa-sort':(flags.flagAN == 1) }" (click)="onSort(1)"></i> -->
            </th>
            <th class="bfr-end-col" rowspan="2">
              Country of Registration
              <!-- <i style="vertical-align:middle; float:right;" class="fa " [ngClass]="{'fa-sort-asc sort-a': (flags.flagST == 2),'fa-sort-desc sort-d': (flags.flagST == 3), 'fa-sort':(flags.flagST == 1) }" (click)="onSort(7)"></i> -->
            </th>
            <th class="bfr-end-col" rowspan="2">
              Vehicle Type
              <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagAN == 2),'fa-sort-desc sort-d': (flags.flagAN == 3), 'fa-sort':(flags.flagAN == 1) }" (click)="onSort(1)"></i> -->
            </th>
            <th class="bfr-end-col" rowspan="2">
              Registration Number
              <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagNM == 2),'fa-sort-desc sort-d': (flags.flagNM == 3), 'fa-sort':(flags.flagNM == 1) }" (click)="onSort(2)"></i> -->
            </th>
            <th class="bfr-end-col" rowspan="2">
              eNatis Number
              <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagNM == 2),'fa-sort-desc sort-d': (flags.flagNM == 3), 'fa-sort':(flags.flagNM == 1) }" (click)="onSort(2)"></i> -->
            </th>
            <th class="bfr-end-col" rowspan="2">
              Licence Expiry Date
              <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagLU == 2),'fa-sort-desc sort-d': (flags.flagLU == 3), 'fa-sort':(flags.flagLU == 1) }" (click)="onSort(3)"></i> -->
            </th>
            <th class="bfr-end-col" rowspan="2">
              GVM
              <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagCT == 2),'fa-sort-desc sort-d': (flags.flagCT == 3), 'fa-sort':(flags.flagCT == 1) }" (click)="onSort(4)"></i> -->
            </th>
            <th class="bfr-end-col" rowspan="2">
              Seating Capacity
              <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagAP == 2),'fa-sort-desc sort-d': (flags.flagAP == 3), 'fa-sort':(flags.flagAP == 1) }" (click)="onSort(5)"></i> -->
            </th>
            <th class="bfr-end-col" rowspan="2">
              Road Worthiness
              <!-- <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagPT == 2),'fa-sort-desc sort-d': (flags.flagPT == 3), 'fa-sort':(flags.flagPT == 1) }" (click)="onSort(6)"></i> -->
            </th>
            <!-- <th class="bfr-end-col end-col" colspan="5">
              Last permit issued
            </th>
          </tr>

          <tr>
            <th class="bfr-end-col">Permit Number</th>
            <th class="bfr-end-col">Permit Type</th>
            <th class="bfr-end-col">Permit Expiry Date</th>
            <th class="bfr-end-col">Permit Status</th> -->
            <th  class="bfr-end-col" rowspan="2">
              <button *ngIf="isExternal" data-dismiss="modal" title="Add a vehicle" class=" btn-add btn btn-primary btn-sm"
                data-toggle="modal" data-target="#addEdit" (click)="createForm()">
                 Add Vehicle
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="tbl-row"
            *ngFor="let item of vehicleRes | paginate: {itemsPerPage:pageSize, currentPage: page ,totalItems: count}">

            <td *ngIf="item.VehicleEntry==null"><span >{{item.vin}}</span></td>
            <td *ngIf="item.VehicleEntry!=null"><span >{{item.VehicleEntry.vin}}</span></td>
            <td *ngIf="item.VehicleEntry!=null">
              <ng-container *ngFor="let cnt of ddlCountries">
                <span *ngIf="item.VehicleEntry.country_id==cnt.id">{{cnt.desc}}</span>
              </ng-container></td>
            <td *ngIf="item.VehicleEntry==null">
              <ng-container *ngFor="let cnt of ddlCountries">
                <span *ngIf="item.country_id==cnt.id">{{cnt.desc}}</span>
              </ng-container></td>
            <td>
              <ng-container *ngFor="let type of vehicletypes">
                <span *ngIf="item.vehicle_type_id==type.id">{{type.description}}</span>
              </ng-container>
            </td>
            <td *ngIf="item.VehicleEntry!=null"><span >{{item.VehicleEntry.registration_number}}</span></td>
            <td *ngIf="item.VehicleEntry==null"><span >{{item.registration_number}}</span></td>

            <td *ngIf="item.VehicleEntry!=null">{{item.VehicleEntry.vehicle_register_num}}</td>
            <td *ngIf="item.VehicleEntry==null">{{item.vehicle_register_num}}</td>
            <td *ngIf="item.VehicleEntry!=null"><span >{{item.VehicleEntry.date_license_expiry | date:'dd/MM/yyyy'}}</span></td>
            <td *ngIf="item.VehicleEntry==null"><span >{{item.date_license_expiry | date:'dd/MM/yyyy'}}</span></td>

            <td *ngIf="item.VehicleEntry!=null"><span >{{item.VehicleEntry.gvn}}</span></td>
            <td *ngIf="item.VehicleEntry==null"><span >{{item.gvn}}</span></td>

            <td *ngIf="item.VehicleEntry!=null"><span >{{item.VehicleEntry.seating_capacity}}</span></td>
            <td *ngIf="item.VehicleEntry==null"><span >{{item.seating_capacity}}</span></td>

            <td *ngIf="item.VehicleEntry!=null"><span >{{item.VehicleEntry.roadworthy_status}}</span></td>
            <td *ngIf="item.VehicleEntry==null"><span >{{item.roadworthy_status}}</span></td>


            <!-- <td><span *ngIf="item.Permit!=null">{{item.Permit.permit_num}}</span></td>
            <td><span *ngIf="item.Permit!=null">
              <ng-container *ngFor="let lis of permittypes">
                <ng-container *ngIf="lis.id==item.Permit.permit_type_id">{{lis.description}}</ng-container>
              </ng-container></span>
            </td>
            <td><span *ngIf="item.Permit!=null">{{item.Permit.date_valid_to}}</span></td>
            <td><span *ngIf="item.Permit!=null">{{item.Permit.status_description}}</span></td> -->
            <td class="btn-show end-col" *ngIf="isExternal">
              <select class="form-control action" name="action"  (change)="selectAction(action,item)" #action>
                <option value="null">Select  </option>
                <!-- <option value="edit">Edit</option> -->
                <option value="view">View</option>
                <!-- <option value="delete">Delete</option> -->
                <!-- <option value="upload">Upload Documents</option>
                <option value="history">Update History</option> -->
              </select>
            </td>
          </tr>
        </tbody>
        <tfoot style="padding:0px;margin:0px;">
          <tr *ngIf="count > 10" style="padding-left:0px;margin-left:0px;">
            <td colspan="8" class="rm-brd" style="padding-left:0px;margin-left:0px;">
              <div  class="row">
                <div class="col-2">
                  <div class="input-group mb-3 rm-brd" style="width:125px!important;height:30px!important;">
                    <div class="input-group-prepend">
                      <label class="input-group-text form-control-sm show-h" for="show-id">Show:</label>
                    </div>
                    <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="pageSize">
                      <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-8 text-center" >
                  <pagination-controls (pageChange)="page = $event"
                    style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
                </div>
              </div>
              <!-- <div *ngIf="IsSearching" class="row">
                <div class="col-2">
                  <div class="input-group mb-3 rm-brd" style="width:125px!important;height:30px!important;">
                    <div class="input-group-prepend">
                      <label class="input-group-text form-control-sm show-h" for="show-id" >Show:</label>
                    </div>
                    <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="pageSize" (change)="onChange()">
                      <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-8 text-center">
                  <pagination-controls (pageChange)="onNextOrPrevious($event)" style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
                </div>
              </div> -->
            </td>
          </tr>
          <tr *ngIf="isEmpty">
            <td colspan="4" class="rm-brd">
              <span class="text-info text-small">No vehicle Entries found.</span>
            </td>
          </tr>
        </tfoot>
      </table>

    </div>
  </div>
</fieldset>

<!--ADD EDIT VIEW Modal -->
<div class="modal fade" id="addEdit" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5);">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle" *ngIf="isEditData==false && isViewData==false">Add Vehicle</h5>
        <h5 class="modal-title" id="exampleModalLongTitle" *ngIf="isEditData==true && isViewData==false">Edit Vehicle</h5>
        <h5 class="modal-title" id="exampleModalLongTitle" *ngIf="isViewData==true">Vehicle Details</h5>
        <button type="button" class="close" data-dismiss="modal" #closebutton aria-label="Close" (click)="close()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body modal-xl">
        <div class="col-md-12" *ngIf="isVehicleLoading"
        style="position: fixed; top: 0; left: 0; width: 100%;height: 100%;    z-index:99;">
        <app-busy [message]="message"></app-busy>
      </div>
        <form [formGroup]="myForm">

          <!-- 1st Row -->
          <div class="row">
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Country of Vehicle Registration<a class="red-asterik"> *</a>
              </label>
              <select class="form-control form-control-sm" id="country_id" name="country_id" (change)="changeCountry(countryId)" #countryId
                formControlName="country_id">
                <option value="" disabled selected>Select country</option>
                <option *ngFor="let country of ddlCountries" [ngValue]="country.id">{{country.desc}}</option>
              </select>
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.country_id.required">Country of vehicle registration is required</p>
            </div> -->
            </div>
          </div>
          <br>

          <!-- 2nd Row -->
          <div class="row">
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                VIN or Chassis Number<a class="red-asterik"> *</a>
              </label>
              <input type="text" #vin (keyup)="checkVin(vin.value)" class="form-control input-sm form-control-sm" id="vin" name="vin"
                formControlName="vin" [readOnly]="isViewData"/>
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.vin.required">VIN or Chassis number is required</p>
            </div> -->
            </div>
            <div class="col-4 sp-fld" *ngIf="!isViewData && found==true">
              <label class="control-label hd-cat">
              </label>
              <button type="button" class="btn btn-md m-clr hd-btn mr-2 mt-2" style="width:100% !important;"  (click)="eNatisUpdate()">Retrieve from eNatis</button>
            </div>
          </div>
          <br>

          <!-- 3rd Row -->
          <div class="row">
            <!-- <div class="col-4 sp-fld" *ngIf="found == false"> -->
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle Registration Number<a class="red-asterik"> *</a>
              </label>
              <input type="text" #reg  maxlength="20" class="form-control input-sm form-control-sm"
                id="registration_number" name="registration_number" formControlName="registration_number" [readonly]="isViewData || isSouthAfrica" />
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.registration_number.required">Vehicle registration number is required</p>
            </div> -->
            </div>
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Engine Number<a class="red-asterik"> *</a>
              </label>
              <input type="text" class="form-control input-sm form-control-sm" id="engine_number" name="engine_number"
                formControlName="engine_number" [readonly]="isViewData || isSouthAfrica"/>
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.engine_number.required">Engine number is required</p>
            </div>-->
            </div>
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Gross Vehicle (GVM)<a class="red-asterik"> *</a>
              </label>
              <input type="text" class="form-control input-sm form-control-sm" (keypress)="numberOnly($event)" id="gvn"
                name="gvn" formControlName="gvn" [readonly]="isViewData || isSouthAfrica" />
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.gvn.required"> Gross Vehicle(GVM) is required</p>
            </div> -->
            </div>
          </div>
          <br>

            <!-- <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle Type<a class="red-asterik"> *</a>
              </label>
              <select class="form-control form-control-sm" id="vehicle_make_id" name="vehicle_make_id"
                formControlName="vehicle_type_id">
                <option value="" disabled selected>Select Vehicle Type</option>
                <option *ngFor="let type of list_vehicle_type" [ngValue]="type.vehicle_type_id">{{type.vehicle_type}}
                </option>
              </select>
              <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.vehicle_make_id.required">Vehicle make is required</p>
            </div>
            </div> -->
            <!-- <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle Make<a class="red-asterik"> *</a>
              </label>
              <select class="form-control form-control-sm" id="vehicle_make_id" name="vehicle_make_id"
                formControlName="vehicle_make_id">
                <option value="" disabled selected>Select Vehicle Make</option>
                <ng-container *ngFor="let make of list_vehicle_make">
                  <option *ngIf="make.is_active" [ngValue]="make.id">{{make.description}}</option>
                </ng-container>
              </select>
            </div> -->
            <!-- <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle Series
              </label>
              <input type="text" class="form-control input-sm form-control-sm" id="vehicle_series" name="vehicle_series"
                formControlName="vehicle_series" />
              <div class="form-control-feedback text-danger text-small">
              <p *ngIf="form.controls.registered_name.errors.required">Company registered name is required</p>
              <p *ngIf="form.controls.registered_name.errors.maxlength">No more than 100 characters allowed for Company Registered Name.</p>
            </div>
            </div> -->
            <!-- <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle Model Derivative
              </label>
              <input type="text" class="form-control input-sm form-control-sm" id="vehicle_model" name="vehicle_model"
                formControlName="vehicle_model" [attr.disabled]="eNatisResult!=null && eNatisResult.Vehicle_model!='' ? true : null" />
             <div class="form-control-feedback text-danger text-small">
              <p *ngIf="form.controls.registered_name.errors.required">Company registered name is required</p>
              <p *ngIf="form.controls.registered_name.errors.maxlength">No more than 100 characters allowed for Company Registered Name.</p>
            </div>
            </div>
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle Colour
              </label>
              <input type="text" maxlength="20" class="form-control input-sm form-control-sm" id="vehicle_colour"
                name="vehicle_colour" formControlName="vehicle_colour" [attr.disabled]="eNatisResult!=null && eNatisResult.Vehicle_colour!='' ? true : null" />
             <div class="form-control-feedback text-danger text-small">
              <p *ngIf="form.controls.registered_name.errors.required">Company registered name is required</p>
              <p *ngIf="form.controls.registered_name.errors.maxlength">No more than 100 characters allowed for Company Registered Name.</p>
            </div>
            </div> -->


          <!-- 4th Row -->
          <div class="row">
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Seating Capacity
              </label>
              <input type="text" class="form-control input-sm form-control-sm" (keypress)="numberOnly($event)"
                id="seating_capacity" name="seating_capacity"  formControlName="seating_capacity" [readonly]="isViewData || isSouthAfrica"/>
              <!-- <div class="form-control-feedback text-danger text-small">
            <p *ngIf="form.controls.registered_name.errors.required">Company registered name is required</p>
            <p *ngIf="form.controls.registered_name.errors.maxlength">No more than 100 characters allowed for Company Registered Name.</p>
          </div> -->
            </div>
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat"></label>
              <label class="control-label hd-cat">
                Registration Year<a class="red-asterik"> *</a>
              </label>
              <input type="text" id='registration_year' name="registration_year" formControlName="registration_year"
                class="form-control input-sm form-control-sm" [readonly]="isViewData || isSouthAfrica" />
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.is_leased.required">This field is required</p>
            </div> -->
            </div>
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                License Expiry Date<a class="red-asterik"> *</a>
              </label>
              <input type="text" class="form-control input-sm form-control-sm" [readonly]="isViewData || isSouthAfrica" [minDate]="currentDate" ngbDatepicker
                #d5="ngbDatepicker" placeholder="dd/mm/yyyy" (focus)="d5.toggle()" id="date_license_expiry"
                name="date_license_expiry" formControlName="date_license_expiry" />
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.date_license_expiry.required">License expiry date is required</p>
            </div> -->
            </div>
          </div>
          <br>

          <!-- 5th Row -->
          <div class="row">
            <div class="col-4 sp-fld">
              <div class="algn">
                <label for='roadworthy_status'>Roadworthy Status<a class="red-asterik"> *</a></label>
                <input type="text" *ngIf="eNatisResult!=null" class="form-control input-sm form-control-sm" id="roadworthy_status" name="roadworthy_status"
                formControlName="roadworthy_status" [readonly]="isSouthAfrica" />
                <select (change)="checkRoadworthy ($event)" type='text' id='roadworthy_status' *ngIf="eNatisResult==null" name="roadworthy_status" formControlName="roadworthy_status"
                  class="form-control-sm" style="width:100%; display:block;" [attr.disabled]="isSouthAfrica ? '' : null">              
                  <option value="" selected disabled>Select status</option>
                  <option value="Roadworthy">Roadworthy</option>
                  <option value="Unroadworthy">Not roadworthy</option>
                </select>
              </div>
            </div>
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat"></label>
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.vin.required">VIN or Chassis number is required</p>
            </div> -->
            </div>
            <div class="col-4 sp-fld" *ngIf="isSouthAfrica || eNatisResult!=null">
              <div class="algn">
                <label for='eNatis_num'>eNatis Number<a class="red-asterik"> *</a></label>
                <input type="text" class="form-control input-sm form-control-sm" id="eNatis_num" name="eNatis_num"
                formControlName="eNatis_num" [readonly]="isSouthAfrica" />
              </div>
            </div>
          </div>
          <br>

          <!-- 6th Row -->
          <div class="row">
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle Type<a class="red-asterik"> *</a>
              </label>
              <select class="form-control form-control-sm"
                      formControlName="vehicle_type_id" id="vehicle_type_id" name="vehicle_type_id">
                <option value="" disabled selected>Select vehicle type</option>
                <option *ngFor="let type of vehicletypes" [ngValue]="type.id">{{type.description}}
                </option>
              </select>
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.vehicle_make_id.required">Vehicle make is required</p>
            </div> -->
            </div>
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Carrier Account<a class="red-asterik"> *</a>
              </label>
              <select class="form-control form-control-sm" id="carrier_id" name="carrier_id"
                formControlName="carrier_id">
                <option value="" disabled selected>Select carrier account</option>
                <option *ngFor="let a of personsList" [ngValue]="a.carrier_id">{{a.account_number}}</option>
              </select>
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.country_id.required">Country of vehicle registration is required</p>
            </div> -->
            </div>
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat"></label>
              <div class="algn">
                <label for='is_leased'>Is the vehicle leased?<a class="red-asterik"> *</a></label>
                <select type='text' id='is_leased' name="is_leased" formControlName="is_leased" class="form-control-sm"
                  (change)="LeaseChange()">
                  <option value="" selected disabled>Select</option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </div>
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.is_leased.required">This field is required</p>
            </div> -->
            </div>
          </div>
          <br>

            <!-- <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle State
              </label>
              <input type="text" class="form-control input-sm form-control-sm" id="vehicle_state" name="vehicle_state"
                formControlName="vehicle_state" />
              <div class="form-control-feedback text-danger text-small">
              <p *ngIf="form.controls.registered_name.errors.required">Company registered name is required</p>
              <p *ngIf="form.controls.registered_name.errors.maxlength">No more than 100 characters allowed for Company Registered Name.</p>
            </div>
            </div> -->
            <!-- <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Start Date<a class="red-asterik"> *</a>
              </label>
              <input type="text" class="form-control input-sm form-control-sm" ngbDatepicker #d9="ngbDatepicker"
                placeholder="dd/mm/yyyy" (focus)="d9.toggle()" id="start_date" name="start_date"
                formControlName="start_date" />
            </div> -->
          <!-- <div class="row">
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle Owner Name<a class="red-asterik"> *</a>
              </label>
              <input type="text" id='vehicle_owner' name="vehicle_owner" formControlName="vehicle_owner"
                class="form-control input-sm form-control-sm" [attr.disabled]="eNatisResult!=null && eNatisResult.Ownership!='' ? true : null" />
             <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.vehicle_owner.required">Vehicle owner name is required</p>
            </div>
            </div>
          </div> -->

          <!-- 7th Row -->
          <div class="row">
            <ng-container  *ngIf="leased=='true'||leased==true">
              <div class="col-4 sp-fld">
                <label class="control-label hd-cat">
                  Lessor Name<a class="red-asterik"> *</a>
                </label>
                <input type="text" class="form-control input-sm form-control-sm" id='vehicle_lessor' name="vehicle_lessor"
                  formControlName="vehicle_lessor" [readonly]="isViewData"/>
                <!-- <div class="form-control-feedback text-danger text-small">
                <p *ngIf="myForm.controls.vehicle_lessor.required">Lessor name is required</p>
              </div> -->
              </div>
              <div class="col-4 sp-fld">
                <label class="control-label hd-cat">
                  Lessee Name<a class="red-asterik"> *</a>
                </label>
                <!-- <input type="text"  class="form-control input-sm form-control-sm" id='vehicle_lessee' name="vehicle_lessee" formControlName="vehicle_lessee"/> -->
                <input type="text" class="form-control input-sm form-control-sm" id='vehicle_lessee' name="vehicle_lessee"
                  formControlName="vehicle_lessee" [readonly]="isViewData"/>
                <div class="form-control-feedback text-danger text-small">
                  <!-- <p *ngIf="myForm.ontrols.vehicle_lessee.required">Lessee name is required</p> -->
                </div>
              </div>
              <div class="col-4 sp-fld">
                <label class="control-label hd-cat">
                  Expiry Date Of Lease<a class="red-asterik"> *</a>
                </label>
                <input type="text" class="form-control input-sm form-control-sm" id='date_lease_expiry'
                  placeholder="dd/mm/yyyy" [placement]="'top'" [minDate]="currentDate" ngbDatepicker
                  ngbDatepicker #d6="ngbDatepicker" (focus)="d6.toggle()"
                  name="date_lease_expiry" formControlName="date_lease_expiry" [readonly]="isViewData"/>
                <!-- <div class="form-control-feedback text-danger text-small">
                <p *ngIf="myForm.controls.date_lease_expiry.required">Expiry date of lease is required</p>
              </div> -->
              </div>
            </ng-container>
          </div>
          <br>
        </form>

      </div>
      <div class="modal-footer">
        <button type="button"  class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="SaveModal()" *ngIf="isEditData==false && isViewData==false">Add Vehicle</button>
        <button type="button"  class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="SaveModal()" *ngIf="isEditData==true && isViewData==false">Save Vehicle</button>
        <button type="button"  class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="CloseModal()" *ngIf="isViewData==true">Close</button>
      </div>
    </div>
  </div>
</div>


